import { capitalize } from '@ember/string';

// Cleans up the @variables for display in the dropdown menu
export function prettyPrintLabel(name) {
  let label = capitalize(name.toLowerCase().replace(/_/g, ' '));
  if (label.startsWith('Field')) {
    label = capitalize(label.substring(6).toLowerCase());
  }
  if (label.startsWith('Field')) {
    label = capitalize(name.substring(6).toLowerCase());
  }
  return label;
}

// Two regex expressions that cover both variable usages
// targets the inner content that drives the display behavior
// e.g. ::USER:: becomes USER and %{visitor_name} becomes visitor_name
const variableRegex = /^\:\:([\S\s]*?)\:\:$/;
export const notificationVariableRegex = /%{([a-z_]+)}/;
function getCleanVariable(variable, regex) {
  const match = regex.exec(variable);
  return match && match.length > 1 ? match[1] : null;
}

// Public method to cleanup the variable name
export function parseRawVariable(rawVariable) {
  const variable = getCleanVariable(rawVariable, variableRegex) || getCleanVariable(rawVariable, notificationVariableRegex) || rawVariable;
  return variable.replace(/(\r\n|\n|\r)/gm, ' ');
}
export const DocFormatEnum = {
  Markdown: 'markdown',
  Nda: 'nda',
  Notification: 'notification',
  MailerV2: 'mailerV2'
};

// Documents each top of character that the editor supports for variables
const charsDefault = {
  first: ':',
  second: ':',
  last: '::'
};
const charsStrong = {
  first: '_',
  second: '_',
  last: '__'
};
const charsNotification = {
  first: '%',
  second: '{',
  last: '}'
};
const charsMailerV2 = charsNotification;
const charsMapping = {
  [DocFormatEnum.Markdown]: {
    normal: charsDefault,
    strong: charsStrong
  },
  [DocFormatEnum.Nda]: {
    normal: charsDefault,
    strong: charsStrong
  },
  [DocFormatEnum.Notification]: {
    normal: charsNotification,
    strong: charsNotification
  },
  [DocFormatEnum.MailerV2]: {
    normal: charsMailerV2
  }
};
export function getDocFormat(schema) {
  return schema.nodeType('doc').attrs.format.default;
}
export function determineValidChars(schema) {
  const format = getDocFormat(schema);
  return charsMapping[format];
}
const inlineDocFormats = [DocFormatEnum.Notification];
export function isInlineDocFormat(docFormat) {
  return inlineDocFormats.includes(docFormat);
}